import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import Typography from '@mui/material/Typography';
import FormLabel from 'components/form/FormLabel';
import PropTypes from 'prop-types';
import React from 'react';
import { CheckboxCheckedIcon, CheckboxIcon } from '../icons';

const CustomCheckboxGroup = React.forwardRef(
  (
    {
      label,
      hint,
      value,
      onChange,
      name,
      options,
      hasError,
      helpText,
      labelKey = 'label',
      valueKey = 'value',
      row,
      exclusive,
      size,
      fullWidth,
      sx,
      disabled,
    },
    ref,
  ) => {
    const handleChange = (event) => {
      const { checked, value: checkedValue } = event.target;
      if (exclusive) {
        onChange({ target: { name, value: checked ? checkedValue : '' } });
      } else {
        let result = value || [];
        if (checked) {
          result.push(checkedValue);
        } else {
          result = result.filter((item) => item !== checkedValue);
        }
        onChange({
          target: {
            name,
            value: result,
          },
        });
      }
    };

    return (
      <FormControl
        disabled={disabled}
        component="fieldset"
        margin="dense"
        variant="standard"
        fullWidth={fullWidth}
        error={hasError}
        sx={sx}
        ref={ref}
      >
        {label && <FormLabel sx={{ pl: 0 }}>{label}</FormLabel>}
        {hint && (
          <Typography variant="caption" color="textSecondary">
            {hint}
          </Typography>
        )}
        <FormGroup row={row}>
          {options.map((i) => (
            <FormControlLabel
              key={i[valueKey]}
              control={
                <Checkbox
                  icon={<CheckboxIcon sx={{ color: 'dividerVariant' }} />}
                  checkedIcon={<CheckboxCheckedIcon />}
                  size={size}
                  onChange={handleChange}
                  checked={
                    exclusive
                      ? value === i[valueKey]
                      : value?.includes(i[valueKey])
                  }
                  name={`${i[labelKey]}-${i[valueKey]}`}
                  value={i[valueKey]}
                />
              }
              label={i[labelKey]}
            />
          ))}
        </FormGroup>
        {hasError && <FormHelperText sx={{ m: 0 }}>{helpText}</FormHelperText>}
      </FormControl>
    );
  },
);

CustomCheckboxGroup.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  hint: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onChange: PropTypes.func,
  name: PropTypes.string,
  options: PropTypes.array,
  hasError: PropTypes.bool,
  helpText: PropTypes.string,
  labelKey: PropTypes.string,
  valueKey: PropTypes.string,
  row: PropTypes.bool,
  exclusive: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  fullWidth: PropTypes.bool,
  sx: PropTypes.object,
};

export default CustomCheckboxGroup;
